import React from "react";
import { OrderDetailsDisconnectionSiteDetails } from "../../../../types/OrderDetailsSiteDetails";
import { Flex } from "../../../Flex";
import { LabelValuePair } from "../../../LabelValuePair";
import { Span } from "../../../Span";
import { OrderDocument } from "../../../../types/OrderDocument";
import { OrderDocuments } from "../OrderDocument";
import { Box } from "../../../Box";
import styled from "styled-components";
import { OrderDisconnectionSiteDetailsMeter } from "./_/OrderDisconnectionSiteDetailsMeter";
import moment from "moment/moment";
import {
  mapAccessIssuesForDisplay,
  withNaCheck,
} from "../../../DisconnectionForm/_/DisconnectionFormUtils/DisconnectionFormUtils";

interface Props {
  address: string;
  disconnectionSiteDetails: OrderDetailsDisconnectionSiteDetails;
  documents: OrderDocument[];
}

const MetersWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.neutrals.ln10};
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.neutrals.ln30};
`;

export const OrderDisconnectionSiteDetails: React.FC<Props> = ({
  address,
  disconnectionSiteDetails,
  documents,
}) => {
  return (
    <Flex flexDirection="column">
      <Span
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mb={2}
        alignSelf="flex-start"
      >
        Property details
      </Span>
      <LabelValuePair
        label="Installation Control Point (ICP)"
        value={disconnectionSiteDetails.icpNumber}
        id="icp-number"
      />
      <LabelValuePair label="Address" value={address} id="address" />
      <LabelValuePair
        label="Job type"
        value="Permanent disconnection (decommission)"
        id="job-type"
      />
      <LabelValuePair
        label="Number of electricity meters to be disconnected"
        value={disconnectionSiteDetails.meters.length}
        id="meters-count"
      />

      {disconnectionSiteDetails.meters.length > 0 && (
        <MetersWrapper
          flexDirection="column"
          borderRadius="radio"
          padding={[3, 3, 3, 4]}
          mb={3}
        >
          {disconnectionSiteDetails.meters.map((meter, index) => {
            return (
              <OrderDisconnectionSiteDetailsMeter
                key={`meters-${index}`}
                idPrefix={"meters"}
                index={index}
                meter={meter}
              />
            );
          })}
        </MetersWrapper>
      )}

      <LabelValuePair
        label="Property type"
        value={disconnectionSiteDetails.type}
        id="property-type"
      />
      <LabelValuePair
        label="Access issues"
        value={mapAccessIssuesForDisplay(
          disconnectionSiteDetails.guardDogs,
          disconnectionSiteDetails.lockedGate,
        )}
        id="access-issues"
      />
      <Span
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mt={6}
        mb={2}
        alignSelf="flex-start"
      >
        Disconnection details
      </Span>
      <LabelValuePair
        label="Reason for removal or disconnection"
        value={disconnectionSiteDetails.removalReason}
        id="removal-reason"
      />
      <LabelValuePair
        label="Requested date of disconnection"
        value={moment(disconnectionSiteDetails.disconnectionDate).format(
          "DD/MM/YYYY",
        )}
        id="disconnection-date"
      />
      <LabelValuePair
        label="Tenants in building"
        value={disconnectionSiteDetails.tenants ? "Yes" : "No"}
        id="tenants"
      />
      <LabelValuePair
        label="Hazards to be aware of"
        value={withNaCheck(disconnectionSiteDetails.hazards)}
        id="hazards"
      />
      <LabelValuePair
        label="Any other information"
        value={withNaCheck(disconnectionSiteDetails.otherInformation)}
        id="other-information"
      />
      <Box mt={6} />
      <OrderDocuments documents={documents} />
    </Flex>
  );
};
